import dayjs from 'dayjs';
import { isDefined } from '../guards/index.js';

function formatter(value, format) {
  return isDefined(value) ? format(value) : void 0;
}
function isValidAttribute(attribute) {
  return isDefined(attribute.value) && attribute.value !== "";
}
function attributeDateFormatter(dateString) {
  return dayjs(dateString).format("dddd, D MMMM YYYY [at] HH:mm");
}
const PROTOCOL_AND_DOUBLE_SLASH_REGEX = /(^\w+:|^)\/\//;
const WWW_REGEX = /^www\./;
const TRAILING_SLASH_REGEX = /\/$/;
const LAST_DOT_REGEX = /\.[^.]*$/;
const NON_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/g;
const upperCaseFirstLetters = (str) => {
  return str.replace(/\b\w/g, (l) => l.toUpperCase());
};
const titleFromUrl = (url) => {
  return upperCaseFirstLetters(url.replace(PROTOCOL_AND_DOUBLE_SLASH_REGEX, "").replace(WWW_REGEX, "").replace(TRAILING_SLASH_REGEX, "").replace(LAST_DOT_REGEX, "").replace(NON_ALPHANUMERIC_REGEX, " ").trim());
};
const formatPercent = (value, options) => Number(value).toLocaleString(void 0, {
  style: "percent",
  maximumFractionDigits: 0,
  ...options
});

export { attributeDateFormatter, formatPercent, formatter, isValidAttribute, titleFromUrl };
//# sourceMappingURL=index.js.map
